import { Box, Card, CardContent, Stack, Typography } from '@mui/material'
import { t } from 'i18next'

import BarChart from '../../Charts/BarChart'
import EventsTable from '../../Events/Tables/Table'
import NotFoundMessage from '../../Shared/Components/NotFoundMessage'

const EventsTab = ({ events, allEvents, onPageChange, paging }) => {
  return (
    <>
      {allEvents?.length && events?.data?.length ? (
        <Stack spacing={20}>
          <Box
            key={'events'}
            id="events"
            sx={{ height: '400px' }}
          >
            <Typography
              variant="h5"
              align="center"
              mb={2}
            >
              {t('devices.events')}
            </Typography>
            <Card variant="standard">
              <CardContent>
                <BarChart data={allEvents} />
              </CardContent>
            </Card>
          </Box>
          <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="center"
            my={4}
          >
            <EventsTable
              events={events}
              onPageChange={onPageChange}
              paging={paging}
            />
          </Stack>
        </Stack>
      ) : (
        <NotFoundMessage
          when={() => !allEvents?.length || !events?.data?.length}
        />
      )}
    </>
  )
}

export default EventsTab
